import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable, catchError, throwError } from 'rxjs';
import { esHttpReportable } from './errores-cliente';
import { ErroresClienteService } from './errores-cliente.service';

/**
 * Reporta al back las fallas HTTP del servidor (5xx) o de red (0) contra la
 * API. No cambia la respuesta: el error sigue su camino a la pantalla. El
 * envio del reporte va por HttpBackend, asi que no vuelve a pasar por aqui.
 */
export const erroresHttpInterceptor = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    const reporter = inject(ErroresClienteService);
    return next(req).pipe(
        catchError((error) => {
            try {
                if (error instanceof HttpErrorResponse) {
                    const enLinea = typeof navigator === 'undefined' || navigator.onLine !== false;
                    if (esHttpReportable(error.status, req.url, environment.apiUrl, enLinea)) {
                        reporter.reportarHttp(error.status, req.method, req.url, error.headers?.get('X-Request-Id'));
                    }
                }
            } catch {
                // Nunca romper la peticion por reportar.
            }
            return throwError(() => error);
        })
    );
};
